// libraries
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// shared
import FormButton from 'shared/components/button';
import GoogleLogo from '-!svg-react-loader!shared/img/google-logo.svg';

import 'stylesheets/components/shared-google-button';

class GoogleButton extends React.Component {
  static propTypes = {
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    modifierClass: PropTypes.string,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node
    ]).isRequired,
    buttonName: PropTypes.string
  };

  static defaultProps = {
    size: 'medium',
    modifierClass: ''
  };

  render() {
    const {size, modifierClass, buttonName} = this.props;

    return (
      <FormButton
        {...this.props}
        buttonName={buttonName}
        color="gray"
        outline
        modifierClass={classnames('shared-google-button', modifierClass)}
      >
        <GoogleLogo className={`shared-google-button-logo-${size}`} />
        {this.props.children}
      </FormButton>
    );
  }
}

export default GoogleButton;
